import React, { useState, useRef } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  OverlayView,
} from "@react-google-maps/api";
import {Image} from 'react-bootstrap';
import styles from "./CustomMap.module.css";
import cn from 'classnames';
import { ASSESTS } from "../../../constant/assest";
import { Swiper as SwiperType } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Modal, Button } from "react-bootstrap";
import CustomButton, { ButtonType } from "../../common/CustomButton/CustomButton";
import GalleryModal from "../GalleryModal/GalleryModal";

type AdminDataType = {
  id: number;
  name: string;
  position: google.maps.LatLngLiteral;
  adminImg: string;
  gallery: string[];
};

type IMapOptions = {
  mapView: {
    lat: number;
    lng: number;
  },
  APIKey: string;
  mapZoom: number;
};

interface ICustomMapProps {
    mapOptions: IMapOptions;
    content: AdminDataType[];
    className?: string;
};

const containerStyle: React.CSSProperties = {
  width: "100%",
  height: "355px",
  border: '8px solid var(--white)',
  boxShadow: '0px 10px 20px 0px rgba(75, 147, 94, 0.08)',
  borderRadius: '20px',
};

interface AdminMarkerProps {
  admin: AdminDataType;
  isOpen: boolean;
  onToggle: (id: number) => void;
}

const AdminMarker: React.FC<AdminMarkerProps> = ({ admin, isOpen, onToggle }) => {
  const swiperRef = useRef<any>(null);

  const [showModal, setShowModal] = useState(false);
  const [startIndex, setStartIndex] = useState(0);

  const handleOpenModal = (idx: number) => {
    setStartIndex(idx);
    setShowModal(true);
  };
  
  return (
    <OverlayView
      position={admin.position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <div
        className={cn(styles.marker)}
      >
        <div className={cn(styles.pointer, !admin.adminImg && styles.dummyPointer)} onClick={() => onToggle(admin.id)}>
          <Image src={admin.adminImg? admin.adminImg : ASSESTS.DUMMYUSER} alt={admin.name} width={24} height={24} />
        </div>

        {isOpen && (
          <div className={cn(
              styles.gallery,
              styles[`itemCount${admin.gallery.length}`]
            )}>
            <Swiper
              modules={[Navigation]}
              spaceBetween={30}
              slidesPerView={3}
              centeredSlides={true}
              loop={true}
              className={styles.slides}
              initialSlide={2}
              onSwiper={(swiper: SwiperType) => (swiperRef.current = swiper)}
            >
              {admin.gallery.map((img, idx) => {
                return (
                <SwiperSlide 
                  key={idx}
                  className={cn(
                    styles.slideItem,
                  )}
                >
                  <div 
                    className={cn(styles.galleryItem)} 
                    onClick={() => handleOpenModal(idx)}
                  >
                    <Image src={img} alt={`gallery-${idx}`} />
                  </div>
                </SwiperSlide>
                )
              })}
            </Swiper>
          </div>
        )}

        <GalleryModal 
          showModal={showModal} 
          onHide={() => setShowModal(false)} 
          gallery={admin.gallery} 
          startIndex={startIndex} 
        />
      </div>
    </OverlayView>
  );
};

const CustomMap: React.FC<ICustomMapProps> = ({mapOptions,  content, className}) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: mapOptions.APIKey,
  });

  const center: google.maps.LatLngLiteral = mapOptions.mapView;

  const [openMarkerId, setOpenMarkerId] = useState<number | null>(null);

  const handleToggle = (id: number) => {
    setOpenMarkerId((prev) => (prev === id ? null : id));
  };

  return (
    <div className={cn(styles.customGoogleMap, className)}>
      {isLoaded && (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={mapOptions.mapZoom}
        >
          {content.map((item) => (
            <AdminMarker
              key={item.id}
              admin={item}
              isOpen={openMarkerId === item.id}
              onToggle={handleToggle}
            />
          ))}
        </GoogleMap>
      )}
    </div>
  );
};

export default CustomMap;
